import React from 'react';
import { apiCall } from '../common/common';
import { displayLog } from '../common/common';

//config
import config from "../config";

const FeedbackContext = React.createContext();


const rootReducer = (state, action) => {
  switch (action.type) {

    case "GETFeedback":
      return {
        isLoaded: true,
        feedBack: action.payload,
      };

    default:
      return {
        ...state
      };
  }
};

const FeedbackProvider = ({ children }) => {

  //  get feedback content
  const [feedBack, setfeedback] = React.useReducer(rootReducer, {
    isLoaded: false,
    feedBack: []
  });

  return (
    <FeedbackContext.Provider value={{
      feedBack, setfeedback
    }}>
      {children}
    </FeedbackContext.Provider>
  );
};

const FeedbackState = () => {
  const context = React.useContext(FeedbackContext);
  return context;
};



//API call to set Help content 
export const getfeedback = async (dispatch, reqData) => {
  let res = await apiCall('GET', 'GETFeedback', '/admin/getFeedbackList', reqData, {}, {}, dispatch)
  if (res && res.data) {
    if (res.data.code === 0) {
      displayLog(0, res.data.message)
    } else {
      dispatch({ type: "GETFeedback", payload: res.data });
      // displayLog(1, res.data.message)
    }
  }
}



export { FeedbackProvider, FeedbackContext, FeedbackState };
